import "./contactme.css";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

const ContactMe = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const si="service_xeueseq"
    const ti="template_71re34g"
    const pa="YFQJ9z1FJmgEz_o0t"
    emailjs
      .sendForm(
        si,
        ti,
        form.current,
        pa
      )
      .then(
        (result) => {
          e.target.reset()
          alert('Your message was sent')
          
        },
        (error) => {
          alert('something wrong! please reach out via alternatives')
        }
      );
  };

  return (
    <section className="contact section" id="contact">
      <h2 className="section__title">Get in Touch</h2>
      <span className="section__subtitle">Contact Me</span>

      <div className="contact__container container grid">
        <div className="contact__content">
          <h3 className="contact__title">Talk to me</h3>

          <div className="contact__info">
            {/* copy from here */}
            <div className="contact__card">
              {/* <i class="uil uil-envelope-edit"></i> */}
              <i className="bx uil-envelope-edit contact__card-icon"></i>
              <h3 className="contact__Card-title">Email</h3>
              <span className="contact__card-data">
              sahilgogavelm@gmail.com
              </span>
              <a
                href="mailto:sahilgogavelm@gmail.com"
                className="contact__button"
              >
                Write Me
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>
            {/* till here */}
            {/* copy from here */}
            {/* <div className="contact__card">
              <i className="bx bxl-whatsapp contact__card-icon"></i>
              <h3 className="contact__Card-title">WhatsApp</h3>
              <span className="contact__card-data">945-3434-545</span>
              <a href="" className="contact__button">
                Write Me{" "}
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div> */}
            {/* till here */}

            {/* copy from here */}
            <div className="contact__card">
              <i className="bx uil-linkedin contact__card-icon"></i>
              <h3 className="contact__Card-title">Linkedin</h3>
              <span className="contact__card-data">sahilgogave</span>
              <a href="https://www.linkedin.com/in/sahilgogave/" className="contact__button"
              target="_blank"
              >
                Write Me
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>
            {/* till here */}
          </div>
        </div>

        <div className="contact__content">
          <h3 className="contact__title">Write me your message</h3>

          <form ref={form} onSubmit={sendEmail} className="contact__form">
            <div className="contact__form-div">
              <label className="contact__form-tag">Name</label>
              <input
                type="text"
                name="name"
                className="contact__form-input"
                placeholder="Enter your Name"
                required
              />
            </div>

            <div className="contact__form-div">
              <label className="contact__form-tag">Mail</label>
              <input
                type="email"
                name="email"
                className="contact__form-input"
                placeholder="Enter your Email"
                required
              />
            </div>

            <div className="contact__form-div contact__form-area">
              <label className="contact__form-tag">Message</label>
              <textarea
                name="message"
                cols="30"
                rows="10"
                className="contact__form-input"
                placeholder="Enter your message"
                required
              ></textarea>
            </div>
            <button className="button button--flex">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactMe;
